/**
 * Supabase client (auth only — data goes through our FastAPI).
 *
 * When VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set (local dev
 * without auth), `supabase` is null and the app runs in dev mode: the old
 * X-User-ID identity, no login screens (mirrors backend AUTH_MODE=dev).
 */

import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabase: SupabaseClient | null =
  url && anonKey ? createClient(url, anonKey) : null;

export const isAuthEnabled = supabase !== null;
